import React from 'react';
import {connect} from 'react-redux';
import {withRouter, Link} from 'react-router-dom';

import {eventByType} from '../../../../api/eventsApi';
import tagular from '../../../../util/tagular';
import * as path from '../../../../util/pathConstructor';
import {openModal} from '../../../../actions/modalActions';
import plus_cyan from '../../../../assets/plus-thick-cyan.svg';
import plus_magenta from '../../../../assets/plus-thick-magenta.svg';
import plus_mnt from '../../../../assets/plus-thick-mnt.svg';
import plus_mnt_hover from '../../../../assets/plus-thick-mnt-hover.svg';
import replay_cyan from '../../../../assets/video-replay-cyan.svg';
import replay_magenta from '../../../../assets/video-replay-magenta.svg';
import replay_mnt from '../../../../assets/video-replay-mnt.svg';
import replay_mnt_hover from '../../../../assets/video-replay-mnt-hover.svg';
import './preferences_mt.scss';

class Preferences_MT extends React.Component {
    constructor(props) {
        super(props);
        this.handleRetakeEvent = this.handleRetakeEvent.bind(this);
    }

    startPath() {
        const allPromptIds = Object.keys(this.props.prompts);
        const firstPrompt = allPromptIds[0];
        const {
            assessment: {name},
            location
        } = this.props;

        return path.getPromptPath(name, location.search, firstPrompt, {clearSearchParams: ['q']});
    }

    handleRetakeEvent(e) {
        const {assessment, inlineParentMetadata} = this.props;
        eventByType('retake-quiz-selected', assessment.id, {inlineParentMetadata});

        tagular.sendElementClickedEvent(e, {
            assessmentName: assessment.internalName,
            action: 'INTERNALLINK'
        });
    }

    render() {
        const {prompts, assessment} = this.props;
        const {resultsConfig} = assessment;

        const allowRetake =
            (resultsConfig && resultsConfig.allowRetake) === undefined
                ? true
                : resultsConfig.allowRetake;
        let retakeButton;
        if (prompts && allowRetake) {
            retakeButton = (
                <Link
                    to={this.startPath()}
                    onClick={e => {
                        this.handleRetakeEvent(e);
                    }}
                    className={`retake-button ${assessment.site}`}
                >
                    { assessment.site && assessment.site == 'mnt' ?
                        (
                            <>
                                <img className="replay mnt icon" src={replay_mnt} />
                                <img className="replay mnthover icon" src={replay_mnt_hover} />
                            </>
                        ) :
                        (
                            <>
                                <img className="replay cyan icon" src={replay_cyan} />
                                <img className="replay magenta icon" src={replay_magenta} />
                            </>
                        )
                    }
                    <span>Retake quiz</span>
                </Link>
            );
        }

        const suppressDisplay = (resultsConfig && resultsConfig.hideFilters === true);
        if (suppressDisplay) {
            return null;
        }

        return (
            <div id="preferences-mt" className="content-container">
                <div className="options">
                    <button
                        className={`add-button ${assessment.site}`}
                        onClick={() => this.props.openModal('addMoreFilters')}
                    >
                        { assessment.site && assessment.site == 'mnt' ?
                        
                                (
                                    <>
                                        <img className="add mnt icon" src={plus_mnt} />
                                        <img className="add mnthover icon" src={plus_mnt_hover} />
                                    </>
                                ) :
                                 (
                                    <>
                                        <img className="add cyan icon" src={plus_cyan} />
                                        <img className="add magenta icon" src={plus_magenta} />
                                    </>
                                )
                        }
                        <span>Add more</span>
                    </button>
                    {retakeButton}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        assessment: state.app.assessment,
        prompts: state.entities.prompts,
        inlineParentMetadata: state.inline.parentMetadata
    };
};

const mapDispatchToProps = dispatch => {
    return {
        openModal: modal => dispatch(openModal(modal))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Preferences_MT));
